import React from "react";
import PublicRoute from "@/components/common/PublicRoute";

// Lazy load public page components
const HomePage = React.lazy(() => import("../pages/HomePage.jsx"));
const AboutUsPage = React.lazy(() => import("../pages/AboutUsPage"));
const ContactUsPage = React.lazy(() => import("../pages/ContactUsPage"));
const RemoveAccountPage = React.lazy(() => import("../pages/RemoveAccountPage"));
const FaqPage = React.lazy(() => import("../pages/FaqPage"));
const PrivacyPolicyPage = React.lazy(() =>
    import("../pages/PrivacyPolicyPage")
);
const FileClaimPage = React.lazy(() => import("../pages/FileClaimPage"));
const Formspage = React.lazy(() => import("../pages/Formspage"));
const LearnAndEarn = React.lazy(() => import("../pages/LearnAndEarn/LearnAndEarnPage.jsx"));
const SignUpPage = React.lazy(() => import("../pages/LearnAndEarn/SignUpPage.jsx"));
const GetStartedPage = React.lazy(() => import("../pages/GetStartedPage"));
const SignupBeforePricingPage = React.lazy(() =>
    import("../pages/SignupBeforePricingPage")
);

// Export route configuration array
export const publicRoutes = [
    {
        path: "/", element:
            <PublicRoute redirectTo="/admin"><HomePage /></PublicRoute> // Redirect authenticated users to dashboard
        // <HomePage />
    },
    { path: "/about-us", element: <AboutUsPage /> },
    { path: "/contact-us", element: <ContactUsPage /> },
    { path: "/delete-account", element: <RemoveAccountPage /> },
    { path: "/faq", element: <FaqPage /> },
    { path: "/privacy-policy", element: <PrivacyPolicyPage /> },
    { path: "/file-claim", element: <FileClaimPage /> },
    { path: "/forms", element: <Formspage /> },
    { path: "/learn-and-earn", element: <LearnAndEarn /> },
    { path: "/learn-earn-sign-up", element: <SignUpPage /> },
    { path: "/get-started", element: <GetStartedPage /> },
    { path: "/signup-before-pricing", element: <SignupBeforePricingPage /> },
];